import { BaseClient } from 'src/common-services/clients/base-client'
import { UserListItem, UserListResponse, UserListsResponse, UpsertUserListRequest } from 'src/common-services'
import { PlaceData } from '@googlemaps/google-maps-services-js'

export class UserListsClient extends BaseClient {
  getListItems(id: string): Promise<UserListResponse> {
    return this.call(`/user-lists/${id}`, 'GET')
  }

  getAllLists(): Promise<UserListsResponse> {
    return this.call(`/user-lists`, 'GET')
  }

  createList(data: UpsertUserListRequest): Promise<UserListResponse> {
    return this.call('/user-lists', 'POST', { data })
  }

  addListItem(listId: string, data: UserListItem): Promise<UserListItem> {
    return this.call(`/user-lists/${listId}`, 'POST', { data })
  }

  deleteList(id: string): Promise<void> {
    return this.call(`/user-lists/${id}`, 'DELETE')
  }

  removeListItem(listId: string, itemId: string): Promise<void> {
    return this.call(`/user-lists/${listId}/item/${itemId}`, 'DELETE')
  }

  updateList(id: string, data: UpsertUserListRequest): Promise<UserListResponse> {
    return this.call(`/user-lists/${id}`, 'PUT', { data })
  }

  getListItemsByIdDetailed(id: string): Promise<UserListItem[]> {
    return this.call(`/user-lists/${id}/items/detailed`, 'GET')
  }

  matchItems(addresses: string[]): Promise<Partial<PlaceData | undefined>[]> {
    return this.call(`/user-lists/match-items`, 'POST', {
      data: addresses,
    })
  }

  addItemsToList(listId: string, items: UserListItem[]): Promise<void> {
    return this.call(`/user-lists/${listId}/items`, 'POST', {
      data: items,
    })
  }
}
